import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getBienKiemSoat = async () => {
  try {
    const response = await axios.get(`${API_URL}/bien_kiem_soat`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bien kiem soat:", error);
    throw error;
  }
};

const getMaBuuCuc = async () => {
  try {
    const response = await axios.get(`${API_URL}/ma_buu_cuc`);
    return response.data;
  } catch (error) {
    console.error("Error fetching ma buu cuc:", error);
    throw error;
  }
};

const getKhachHang = async () => {
  try {
    const response = await axios.get(`${API_URL}/load_khach_hang`);
    return response.data;
  } catch (error) {
    console.error("Error fetching khach hang kinh doanh:", error);
    throw error;
  }
};

const getChuyenKinhDoanh = async () => {
  try {
    const response = await axios.get(`${API_URL}/load_chuyen_kinh_doanh`);
    return response.data;
  } catch (error) {
    console.error("Error fetching chuyen kinh doanh:", error);
    throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
  }
};

// Hàm lấy danh sách chuyến tài xế
const getChuyenData = async () => {
  try {
    const response = await axios.get(`${API_URL}/chuyen_data`);
    return response.data;
  } catch (error) {
    console.error("Error fetching chuyen data:", error);
    throw error;
  }
};

const getMaChuyen = async () => {
  try {
    const response = await axios.get(`${API_URL}/load_ma_chuyen`);
    return response.data;
  } catch (error) {
    console.error("Error fetching ma buu cuc:", error);
    throw error;
  }
};

// Hàm lấy danh sách tài xế đã được gán chuyến xe
const getGanUsernameChuyenXe = async () => {
  try {
    const response = await axios.get(`${API_URL}/gan_username_chuyen_xe`);
    return response.data;
  } catch (error) {
    console.error("Error fetching gan username chuyen xe:", error);
    throw error;
  }
};

// Đặt tên cho object trước khi export
const LoadThongTinService = {
  getBienKiemSoat,
  getMaBuuCuc,
  getChuyenData,
  getMaChuyen,
  getKhachHang,
  getChuyenKinhDoanh,
  getGanUsernameChuyenXe,
};

export default LoadThongTinService;
